import { buildConversationFunnelStages } from '../wingmanIntelligenceMetrics';
import ApexFunnelChart from './ApexFunnelChart';

const ConversationFunnelChart = ({
  title = 'Wingman Conversation Funnel',
  stages = buildConversationFunnelStages(),
}) => <ApexFunnelChart title={title} stages={stages} />;

export default ConversationFunnelChart;
